import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import ProductService from '../services/Product'
import { useNavigate, useParams } from 'react-router-dom'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import DefaultImage from '../assets/images/productDefault.png'
import { Heart } from 'react-feather';
import Loader from '../component/Loader'
import SingleProduct from '../component/SingleProduct'
import CartService from '../services/Cart'
import AlertMsg from '../component/AlertMsg';
import WishListOutLine from '../assets/images/heartOutline.png'
import { useDispatch } from 'react-redux';
import { addTotalCartItems } from '../redux/slices/countSlice'
import toast from 'react-hot-toast'
import useScrollToTop from '../hooks/useScrollToTop'
import ProfileService from '../services/Profile'
import NoData from '../component/NoData'

const ProductList = () => {
    useScrollToTop()
    const [loading, setLoading] = useState(true);
    const [isProductData, setIsProductData] = useState([]);
    const [isProductCategoryName, setIsProductCategoryName] = useState('');
    const [issearchText, setIsSearchText] = useState('');
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [isWishListSuccess, setIsWishListSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [showWishListAlert, setShowWishListAlert] = useState(false);
    // const { product_id,category_id} = useParams();
    const [productList, setProductList] = useState([]);
    const [prodInfo, setProdInfo] = useState();
    // const [wishlistCount, setWishlistCount] = useState(0);

    const { catgryId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        const ProductListFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const searchText = '';
                const ProductListResponse = await ProductService.allCatalogueProduct(1, catgryId, searchText, token);
                console.log('ProductListResponse', JSON.stringify(ProductListResponse));
                // console.log('ProductListResponseeeee', ProductListResponse.data[0].category_name);
                if (!ProductListResponse.error) {
                    if(ProductListResponse.data.is_catalog == 1 && ProductListResponse.data.products.length > 0) {
                        setProdInfo({canRedeem: ProductListResponse.data.can_redeem, mrpLabel: ProductListResponse.data.mrp_label});
                        setIsProductData(ProductListResponse.data.products)
                        setIsProductCategoryName(ProductListResponse.data.products[0].category_name)
                    } else {
                        toast.error("No data found");
                    }   
                }
                else (
                    setIsProductData([])
                )
                setLoading(false)
            }
            catch (e) {
                setLoading(false)
                console.error("ERROR PRODUCT", e)
            }

        }
        ProductListFetchData()
    }, [catgryId])
    //Cart Count
    const startCartCount = async () => {
        try {
            const token = localStorage.getItem('access_token')

            const startCartCountResponse = await CartService.cartItemCount(token)

            if (startCartCountResponse.error == false && startCartCountResponse.data.status == true) {

                dispatch(addTotalCartItems({
                    cartCount: startCartCountResponse?.data?.cartCountProducts
                }))
            }

        }
        catch (e) {
            console.error('startCartCountResponse')
        }
    }
    // Wishlist count
    // const wishlistCount = async () => {
    //     try {
    //         const token = localStorage.getItem('access_token')
    //         const wishlistCountResponse = await CartService.wishlistCount(token);
    //         if (wishlistCountResponse.error == false && wishlistCountResponse.data.status == true) {
    //             dispatch(addWishlistCount({
    //                 wishlistCount: wishlistCountResponse?.data?.wishlistCount
    //             }))
    //         }
    //     }
    //     catch (e) {
    //         console.error('wishlistCountResponse')
    //     }
    // }
    //Add To Cart
    const handleAddCart = async (product_id, catalog_id) => {
        const token = localStorage.getItem('access_token');
        const payload = {
            product_id: product_id + '',
            quantity: '1',
            ip: '',
            catalog_id: catalog_id + '',
        };
        const res = await CartService.addToCart(payload, token);
        if (!res.error) {
            startCartCount()
            toast.success(res.data.message)
        }

    }
    //Search
    const handleSearch = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('access_token');
            const searchText = issearchText;
            console.log("searchtext", searchText);
            
            const response = await ProductService.allCatalogueProduct(1, catgryId, searchText, token);

            if (!response.error && response.data.is_catalog == 1 && response.data.products.length > 0) {
                setProdInfo({canRedeem: response.data.can_redeem, mrpLabel: response.data.mrp_label});
                setIsProductData(response.data.products)
                setIsProductCategoryName(response.data.products[0].category_name)
            }
            else (
                setIsProductData([])
            )
            setLoading(false);
        } catch (error) {
            console.error('Error fetching search results:');
            setLoading(false);
        }
    };
    //Add to WishList
    // const handleWishList = async (product_id, category_id) => {
    //     try {
    //         const token = localStorage.getItem('access_token');
    //         if (!token) {
    //             toast.error("Please login to add to wishlist");
    //             return;
    //         }
    //         const payload = {
    //             productId: parseInt(product_id) + '',
    //             name: 'Default List',
    //             description: 'Your Default WishList',
    //             toggle: 'create',
    //             quantity: '1',
    //             ip: '',
    //             catalog_id: category_id + '',
    //         };
    

    
    //         const response = await CartService.addToWishlist(payload, token);
    

    
    //         if (!response.error) {
    //             startCartCount();
    //             toast.success("Product added to wishlist");
    //         } else {
    //             toast.error("Failed to add to wishlist");
    //         }
    //     } catch (error) {
    //         console.error("Error adding to wishlist:");
    //         toast.error("Something went wrong");
    //     }
    // };
    const handleWishList = async (product_id) => {
        try {
            const token = localStorage.getItem('access_token');

            const payload = {
                productId: product_id.toString(),
                name: 'Default List',
                description: 'Your Default WishList',
                toggle: 'create',
            };
    
    
            const response = await CartService.addToWishlist(payload, token);
    
            if (!response.error) {
                toast.success("Product added to wishlist");
                // setWishlistCount((prevCount) => prevCount + 1); 
            } else {
                toast.error("Failed to add to wishlist");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };
    

    const navigate = useNavigate()
    const handleViewDetails = (product_id, category_id) => {

        navigate(`/rewards-category-list/${product_id}/${category_id}`);
    }

    const getProductList = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('access_token');
            const res = await ProfileService.getWishlist(token);
            if (res.statusCode == 401) {
                // logoutHandler(navigation)
                    localStorage.clear();
                     window.location.reload();
                    dispatch(addTotalCartItems({
                        cartCount:0
                    }))
                    navigate('/');
                }
                setLoading(false);
                if(res.error === false){
                    setProductList(res.data.wishlistProductsDetails)
                } else {
                    setProductList([])
                }

        } catch (error) {
        }
    }

    return (
        <>
            {loading && <Loader />}

            <BreadCrumbSecttion
                pageTitle={isProductCategoryName}
                parentPageOfCurrentPage="Rewards Category List"
                currentPageName={isProductCategoryName}
                breadCrumbPathName='/rewards-category-list' />
            <section className='padTop50'>
                <Container>

                    <Row className='productSearchPanelBox'>
                        <Col xs={12} lg={4}>
                            <div className='productSearchPanel mb-3'>
                                <div className="form-group has-search">
                                    <input
                                        type="text"
                                        className="form-control mb-0"
                                        placeholder="Search"
                                        value={issearchText}
                                        onChange={(e) => setIsSearchText(e.target.value)}
                                    />
                                    <PrimaryGradientButton buttonText='Search' onClick={handleSearch} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {isProductData.length === 0 && !loading && <NoData />}
                        </Col>
                    </Row>

                    <Row>

                        {isProductData?.map((item, index) => {
                            const { price_in_points, product_name, short_desc, price, product_images, product_id, catalog_id, category_id, mrp_in_point } = item
                            const imgSrc = product_images.length > 0 ? product_images[0].product_image : DefaultImage;

                            return (
                                <>
                                <Col xs={12} sm={6} md={4} lg={3} key={index}>
                                <SingleProduct
                                    prodId={product_id}
                                    categoryId={category_id}
                                    heart={WishListOutLine}
                                    onPressHeart={(id, category_id) => {
                                        handleWishList(id, catalog_id);
                                    }}
                                    productName={product_name}
                                    shortDesc={short_desc}
                                    price={price_in_points}
                                    mrp_in_point={mrp_in_point}

                                    getTxt="Get within 10 days"
                                    productImage={imgSrc}
                                    onClick={() => handleViewDetails(product_id, category_id)}
                                    onClickCart={() => handleAddCart(product_id, catalog_id)}
                                    prodInfo={prodInfo}
                                />

                                </Col>
                                </>
                            )
                        })}

                    </Row>
                    <Row>
                        <Col>
                            <div className='productListAlert alertBoxWrap'>
                                {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                    heading={isLoginSuccess.heading}
                                    text={isLoginSuccess.text}
                                />
                                }
                            </div>
                            <div className='productListAlert alertBoxWrap'>
                                {showWishListAlert && <AlertMsg alertBoxColor={isWishListSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                    heading={isWishListSuccess.heading}
                                    text={isWishListSuccess.text}
                                />
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    )
}

export default ProductList